import { UploadError } from './UploadError';

export class FileConflict extends UploadError {
    radarName = 'error_{SOURCE}_file-upl-conflict';
    message = 'Такой файл уже грузится в данный момент.';
}
